module.exports = __webpack_public_path__ + "static/media/James-wong-thumbnail.0bdf2330.jpg";